import AppliedCouponCode from '../../../types/AppliedCouponCode';
import ErrorList from '../../../types/UI/ErrorList';

export type CouponStatus =
    | 'canApply'
    | 'applied'
    | 'canValidate'
    | 'validated'
    | 'error';

const determineStatus = (
    applyCouponCodeUrl: string | undefined,
    appliedCouponCode: AppliedCouponCode | undefined,
    errors: ErrorList | undefined
): CouponStatus => {
    if (errors) {
        return 'error';
    }

    if (applyCouponCodeUrl) {
        return appliedCouponCode ? 'applied' : 'canApply';
    }

    return appliedCouponCode ? 'validated' : 'canValidate';
};

export default determineStatus;
